import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { MediaHelper } from '../../helpers/mediaHelper';
import { useGetModuleById } from 'src/modules/modules/hooks/useGetModuleById/useGetModuleById';
import RenderClubAdmin from 'src/shared/components/renderClubAdmin/renderClubAdmin';
export function Media({ onSetThumbnail }) {
    const form = useFormContext();
    const { moduleId, pageId } = useParams();
    const moduleRequest = useGetModuleById(moduleId);
    const isFreeModule = moduleRequest.data?.publicModule;
    const currentMedias = form.watch('medias');
    function handleChange(newMedias) {
        if (MediaHelper.isEqualMedias(currentMedias, newMedias)) {
            return;
        }
        form.setValue('medias', newMedias, {
            shouldDirty: true
        });
    }
    if (!moduleRequest.data) {
        return null;
    }
    return (_jsx(RenderClubAdmin, { __name: "FilePlayerGroup", onChange: handleChange, isModuleFree: isFreeModule, medias: currentMedias, onSetThumbnail: onSetThumbnail, ...(pageId !== 'new' && { entityId: pageId }) }));
}
